import _ from 'underscore'
import OldBaseFormMediator from './OldBaseFormMediator'
import CostReportEditFormConfigController from './edit_config_controller/costOfWork/CostReportEditFormConfigController'
import CostCSVPreviewGenerator from './preview/csv/cost/CostCSVPreviewGenerator'
import CostHTMLPreviewGenerator from './preview/html/cost/CostHTMLPreviewGenerator'
import BaseFormMediator from './BaseFormMediator'
import ScrollUtils from '../util/ScrollUtils'
import $ from 'jquery'
import ATReportParamsStringBuilder from './reportParamsStringBuilder/ATReportParamsStringBuilder'

export default function CostFormMediator () {}

CostFormMediator.prototype = _.create(OldBaseFormMediator.prototype);

CostFormMediator.prototype.init = function ( config ) {
    OldBaseFormMediator.prototype.init.call(this, config);
    return this;
};

CostFormMediator.prototype.initParamsStringBuilder = function(config) {
    return new ATReportParamsStringBuilder({
        data: {
            users: config.users,
            userGroups: config.userGroups,
            timeZoneGroups: config.timeZoneGroups,
            cpList: config.cpList,
            manageableUserIds: ATReportsStore.getManageableUserIds()
        },
        reportAuthorizationInfo: ATReportsStore.getReportAuthorizationInfo(),
    })
}

CostFormMediator.prototype.initEditConfigController = function ( config ) {
    const self = this;
    return new CostReportEditFormConfigController().init(
            {
                panelId: "mainContainer",
                reportAuthorizationInfo: config.reportAuthorizationInfo,
                reportParameters: config.reportParameters,
                users: config.users,
                manageableUsersIds: config.manageableUserIds,
                userGroups: config.userGroups,
                timeZoneGroups: config.timeZoneGroups,
                cpList: config.cpList,
                customersWithMaIds: config.customersWithMaIds,
                projectsWithMaIds: config.projectsWithMaIds,
                changeCallback: function(){ self.changeParametersCallback()}
            } )
};

CostFormMediator.prototype.initCsvGenerator = function(){
    return new CostCSVPreviewGenerator().init();
};

CostFormMediator.prototype.initHtmlGenerator = function(){
    return new CostHTMLPreviewGenerator().init();
};

CostFormMediator.prototype.generateCSVPreview = function(reportParameters) {
    BaseFormMediator.prototype.generateCSVPreview.apply(this, arguments)
    this._initPreviewCustomScroll()
}

CostFormMediator.prototype.generateHtmlPreview = function(reportParameters) {
    BaseFormMediator.prototype.generateHtmlPreview.apply(this, arguments)
    this._initPreviewCustomScroll()
}

CostFormMediator.prototype._initPreviewCustomScroll = function() {
    ScrollUtils.addHorizontalScroll($("#reportPreviewPlaceholder"), {isFaded: false})
}



// WEBPACK FOOTER //
// ./web/js/reports/CostFormMediator.js